import React from 'react';

import './search-button-group.scss';

interface SearchButtonGroupProps {
  className?: string;
}

function SearchButtonGroup(
  props: React.PropsWithChildren<SearchButtonGroupProps>
) {
  const { className = '', children } = props;

  return (
    <div
      className={`search-button-group ${className}`}
      role="row"
      styleName="group"
    >
      {children}
    </div>
  );
}

export default SearchButtonGroup;
